"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingOverlay = LoadingOverlay;
exports.LoadingCard = LoadingCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const cn_1 = require("../lib/cn");
const icon_1 = require("./icon");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 30 Oct 2026 · A SURFACE WHOSE FIGURES ARE FOR SOMETHING ELSE THAN ASKED.   │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The product owner, on the project time machine: a past day can take seconds to rebuild, and
 * the dashboard sat showing the previous day's figures with nothing to say they were about to
 * change. This lays a scrim over the surface and says what is being read.
 *
 * ⚠️ **For a changed QUESTION only — a picked date, not a refresh.** `state-rules.md` §1 keeps a
 * live refresh behind the figures already shown; this is for the case where the figures shown
 * answer a question the reader no longer asked. The caller decides which it is.
 *
 * ⚠️ The parent is `relative`; the card is `sticky`, so it stays in view on a tall dashboard.
 * One `role="status"`, which is the surface's one announcer while it shows.
 */
function LoadingOverlay({ show, label, slowNote, slowAfterMs = 3000, className, }) {
    if (!show)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, cn_1.cn)('bg-background/60 absolute inset-0 z-20', className), children: (0, jsx_runtime_1.jsx)("div", { className: "sticky top-24 flex justify-center pt-16", children: (0, jsx_runtime_1.jsx)(LoadingCard, { label: label, slowNote: slowNote, slowAfterMs: slowAfterMs }) }) }));
}
/**
 * 3 Nov 2026 · the overlay's card on its own — for a FIRST load, where there are no figures to lay
 * a scrim over and the card stands where the surface will be. Same slow note, same one announcer.
 *
 * ⚠️ **The note is inside the one `role="status"`**, so a screen reader hears it when it appears
 * rather than meeting a second live region that competes with the first.
 */
function LoadingCard({ label, slowNote, slowAfterMs = 3000, className, }) {
    const [slow, setSlow] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (slowNote === undefined)
            return undefined;
        const timer = window.setTimeout(() => {
            setSlow(true);
        }, slowAfterMs);
        return () => {
            window.clearTimeout(timer);
        };
    }, [slowNote, slowAfterMs]);
    return ((0, jsx_runtime_1.jsxs)("div", { role: "status", "aria-live": "polite", className: (0, cn_1.cn)('bg-card text-muted-foreground flex max-w-[420px] flex-col gap-1 rounded-lg border px-4 py-2.5 text-[12.5px] shadow-sm', className), children: [(0, jsx_runtime_1.jsxs)("span", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(icon_1.Icon, { name: "refresh-cw", size: 14, className: "animate-spin" }), label] }), slow && slowNote !== undefined ? ((0, jsx_runtime_1.jsx)("span", { className: "text-muted-foreground/80 pl-[22px] text-[11.5px]", children: slowNote })) : null] }));
}
//# sourceMappingURL=loading-overlay.js.map